import React from "react";

const Support = () => {
  return (
    <div className="container mx-auto p-6 max-w-3xl">
      <h1 className="text-3xl font-bold text-center mb-6">Support - Roomease</h1>
      <p className="text-gray-700 text-center mb-6">
        We’re here to help! If you have any questions, concerns, or need
        assistance with your Roomease experience, check out the resources below.
      </p>

      <div className="bg-gray-100 p-4 rounded-lg shadow-md mb-6">
        <h2 className="text-2xl font-semibold mb-4">Frequently Asked Questions (FAQs)</h2>
        <ul className="list-disc pl-5 text-gray-800">
          <li className="mb-3">
            <strong>How do I create a profile?</strong>
            <p>
              To create a profile, download the Roomease app, sign up with your email
              or phone number, and fill in your details, including preferences for
              finding your ideal roommate.
            </p>
          </li>
          <li className="mb-3">
            <strong>How does Roomease match me with a roommate?</strong>
            <p>
              Roomease uses your preferences, lifestyle choices, and location to suggest
              potential roommates who align with your needs.
            </p>
          </li>
          <li className="mb-3">
            <strong>Can I edit my profile details later?</strong>
            <p>Yes! You can update your profile at any time from the settings section of the app.</p>
          </li>
          <li className="mb-3">
            <strong>How do I contact a potential roommate?</strong>
            <p>
              Once you find a match, you can start a conversation directly through the
              in-app chat feature.
            </p>
          </li>
          <li className="mb-3">
            <strong>How do I delete my Roomease account?</strong>
            <p>
              You can delete your account by visiting this link:
              <a
                href="https://roomease.co.in/#/delete-account"
                className="text-blue-600 underline ml-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Delete Account
              </a>
              . Please note that account deletion is permanent and cannot be undone.
            </p>
          </li>
        </ul>
      </div>

      <div className="bg-gray-100 p-4 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold mb-2">Need Further Assistance?</h2>
        <p>
          If you have any issues that aren’t covered here, feel free to reach out to us at
          <a
            href="mailto:support@roomease.co.in"
            className="text-blue-600 underline ml-1"
          >
            support@roomease.co.in
          </a>
          . Our team is available to assist you with any inquiries.
        </p>
      </div>
    </div>
  );
};

export default Support;